/*
export class PlanRouteParams{
	constructor(plannerParams){
		var _plannerParams = plannerParams;

		Object.defineProperty(this,'plannerParams',{
			get : function(){ return _plannerParams }
		})

	}
}
*/
/**
 Note: the properties should be enumerable, otherwise there won't be listed in the object.keys in planroute.service.mjs
 */

export class PlanRouteParams{
	constructor(){
		var  _fromLabel, _fromLat, _fromLon, _toLabel, _toLat, _toLon, _date, _time, _deparr, _wheelchair, _planner;
		
		Object.defineProperty(this,'fromLabel',{
			set : function(l){ _fromLabel = l },
			get : function(){  return _fromLabel },
			enumerable : true 
		});



		Object.defineProperty(this,'fromLat',{
			set : function(v){
				_fromLat = v;
			},
			get : function(){
				return _fromLat;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'fromLon',{
			set : function(v){
				_fromLon = v;
			},
			get : function(){
				return _fromLon;
			},
			enumerable : true
		});

		Object.defineProperty(this,'toLabel',{
			set : function(l){ _toLabel = l },
			get : function(){  return _toLabel },
			enumerable : true 
		});

		
		Object.defineProperty(this,'toLat',{
			set : function(v){
				_toLat = v;
			},
			get : function(){
				return _toLat;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'toLon',{
			set : function(v){
				_toLon = v;
			},
			get : function(){
				return _toLon;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'date',{
			set : function(v){
				_date = v;
			},
			get : function(){
				return _date;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'time',{
			set : function(v){
				_time = v;
			},
			get : function(){
				return _time;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'deparr',{
			set : function(v){
				_deparr = v;
			},
			get : function(){
				return _deparr;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'wheelchair',{
			set : function(v){
				_wheelchair = v;
			},
			get : function(){
				return _wheelchair;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'planner',{
			set : function(v){
				_planner = v;
			},
			get : function(){
				return _planner;
			},
			enumerable : true
		});
		
	}
}


